import { ModalProps, Select, Stack } from "@mantine/core"
import { FieldFilter } from "./FieldFilter"
import { FormButtonGroup } from "../form-button-group"
import { CancelButton, PrimaryButton } from "../Buttons"
import { useTranslation } from "react-i18next"
import { DefaultModal } from "../default-modal"
import { FieldFilterValue, FieldType } from "@/orval/gen/model"

interface Props extends ModalProps {
  fieldTypes: FieldType[]
  onAdd: (record: { type: number; value: FieldFilterValue }) => void
  values?:
    | {
        [key: string]: FieldFilterValue
      }
    | null
    | undefined
}

export function AddFieldFilterModal({
  fieldTypes,
  onAdd,
  values,
  ...props
}: Props) {
  const initialType = fieldTypes[0]
  const initialValue = values?.[initialType?.name]
  const [type, setType] = React.useState<FieldType | null>(initialType)
  const [value, setValue] = React.useState<string[] | null | undefined>(
    initialValue?.values
  )
  const { t } = useTranslation("app_server")

  const handleAdd = () => {
    if (type && value !== null) {
      onAdd({
        type: type.id,
        value: { dataType: type.dataType, values: value },
      })
      props.onClose()
    }
  }
  return (
    <DefaultModal title={t("FieldFilter")} {...props}>
      <Stack>
        <Select
          label={t("Fields")}
          value={type?.name}
          data={fieldTypes.map((type) => type.name)}
          onChange={(value) => {
            if (value) {
              setType(fieldTypes.find((type) => type.name === value) ?? null)
              const initialValue = values?.value
              if (initialValue) {
                setValue(initialValue.values)
              } else {
                setValue(undefined)
              }
            }
          }}
        />
        {type && (
          <FieldFilter
            label={type.name}
            fieldType={type}
            value={value}
            onChange={(value) => setValue(value)}
          />
        )}
        <FormButtonGroup>
          <CancelButton onClick={props.onClose} />
          <PrimaryButton onClick={handleAdd}>{t("Add")}</PrimaryButton>
        </FormButtonGroup>
      </Stack>
    </DefaultModal>
  )
}
